import styled from 'styled-components';

export const HealthUnitsInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 169px);
  gap: 12px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 169px));
  }
`;
